import { AttributesSelector, Checkbox, Field } from '@workwhile/ui'
import React, { useMemo } from 'react'
import { usePositionsContextValue } from 'pages/Positions/Positions/context/PositionsProvider'
import { selectableColumns } from './columns'

export const ColumnsFilter = () => {
  const {
    state: { selectedColumnsFilters },
    actions: { setSelectedColumnsFilters },
  } = usePositionsContextValue()

  const selectedColumnAttributes = useMemo(() => {
    const selectedColumnsSet = new Set(selectedColumnsFilters)
    return selectableColumns
      .map((column) =>
        selectedColumnsSet.has(column.id) ? column.label : undefined
      )
      .filter((item): item is NonNullable<typeof item> => Boolean(item))
  }, [selectedColumnsFilters])

  const selectableColumnsCheckboxes = useMemo(() => {
    return selectableColumns.map((column) => {
      const isSelected = selectedColumnsFilters.includes(column.id)
      return (
        <Field key={column.id}>
          <Checkbox
            value={isSelected}
            onChange={() => {
              setSelectedColumnsFilters((prev) => {
                if (prev.includes(column.id)) {
                  return prev.filter((c) => c !== column.id)
                }
                return [...prev, column.id]
              })
            }}
          >
            <span>{column.label}</span>
          </Checkbox>
        </Field>
      )
    })
  }, [selectedColumnsFilters])

  return (
    <AttributesSelector
      label="Columns"
      rootGroupTitle="Toggle Columns"
      selectedAttributes={selectedColumnAttributes}
      onClearAll={() => {
        setSelectedColumnsFilters([])
      }}
      selectedAttributeLimit={0}
      groups={[
        <AttributesSelector.Group
          key="position-columns"
          title="Columns"
          numberOfSelectedAttributes={selectedColumnAttributes.length}
        >
          {selectableColumnsCheckboxes}
        </AttributesSelector.Group>,
      ]}
    />
  )
}
